import DropdownMenubar from "../Components/Menubar/DropdownMenubar.jsx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";
import { HiMiniXMark } from "react-icons/hi2";
import { IoMdCheckmark } from "react-icons/io";
import { Badge } from "primereact/badge";

const DD = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const getVendorInfo = (row, handleCellClick) => {
  return DD([
    {
      label: "APPROVE",
      icon: (
        <div className="  text-white  rounded-full bg-green-600">
          {" "}
          <IoMdCheckmark className="" />
        </div>
      ),

      command: () => {
        handleCellClick(row, "Approved");
      },
    },
    {
      label: "REJECT",
      icon: (
        <div className="  text-white  rounded-full bg-red-600">
          {" "}
          <HiMiniXMark className="" />
        </div>
      ),
      command: () => {
        handleCellClick(row, "Rejected");
      },
    },
  ]);
};
export const columns = [
  {
    field: "created_by",
    header: "Vendor",
    accessor: (row, handleCellClick) => (
      <div className="w-fit">
        <div className="overflow-hidden flex flex-col justify-center items-center">
          {row?.created_by?.profile_image ? (
            <LazyLoadImage
              src={row?.created_by?.profile_image}
              alt="img"
              loading="lazy"
              effect="blur"
              wrapperProps={{
                style: { transitionDelay: "1s" },
              }}
              className="rounded-full w-20 h-20"
            />
          ) : (
            <div className="rounded-full w-20 h-20 bg-[#d2d2d2] flex justify-center items-center">
              <FcShop className="text-[3rem]  text-[#02aabd93]" />
            </div>
          )}
          <p className="mt-2">{row?.created_by?.first_name}</p>
        </div>
      </div>
    ),
  },
  {
    field: "Category",
    header: "Category Name",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "Category")} className="">
          <p>{row?.Category?.name}</p>
          {/* <p className="w-[6rem]">
            {moment(row?.order_date).utc().format("DD MMM YYYY hh:mma")}
          </p> */}
        </div>
      </>
    ),
  },
  {
    field: "name",
    header: "Subcategory Name",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "name")} className="">
          <p>{row?.name}</p>
          {/* <p className="w-[6rem]">
            {moment(row?.order_date).utc().format("DD MMM YYYY hh:mma")}
          </p> */}
        </div>
      </>
    ),
  },

  {
    field: "status",
    header: "Status",
    accessor: (row, handleCellClick) => (
      <>
        {row?.status && (
          <Badge
            className="w-[6rem]"
            severity={
              row?.status === "Rejected"
                ? "danger"
                : row?.status === "Pending"
                ? "warning"
                : "success"
            }
            value={row?.status}
          />
        )}
      </>
    ),
  },
  {
    field: "action",
    header: "Action",
    accessor: (row, handleCellClick) => getVendorInfo(row, handleCellClick),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Filter by A/U",
    inputName: "status",
    options: [
      {
        name: "Approved",
        code: "Approved",
      },
      {
        name: "Rejected",
        code: "Rejected",
      },
      {
        name: "Pending",
        code: "Pending",
      },
    ],
  },
];
